import * as adl from 'pf-advanced-logic';
// import * as adl from '../../../../../../../../pf-advanced-logic/dist';

const conditionService = new adl.QuestionnaireConditionService();
const ruleService = new adl.RuleService(conditionService);
const statementService = new adl.StatementService(ruleService);
const outcomeService = new adl.OutcomeService();

export const questionnaireLogicService = new adl.QuestionnaireLogicService(
  statementService,
  ruleService,
  outcomeService,
  conditionService,
);

export const questionnairePathTraversal = new adl.QuestionnairePathTraversal(
  questionnaireLogicService,
);
